module.exports = __webpack_public_path__ + "img/serifnew_box27.54f26676.jpg";